"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ExpandCollapse = _interopRequireDefault(require("./ExpandCollapse"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 'Accordion' is a shorthand for an ExpandCollapse where only one item may be open at a time
 */const Accordion = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandCollapse.default, {
  ref: ref,
  ...props,
  maxOpen: 1
}));
Accordion.displayName = 'Accordion';
Accordion.propTypes = _ExpandCollapse.default.propTypes;
var _default = exports.default = Accordion;